/**
 * Procedure Categories and Procedures for MD in Pharmacology students
 * Extracted with strict evidence from official NMC PDF
 */
export const PHARMACOLOGY_PROCEDURES = {
  "Experimental Pharmacology & Bioassays": [
    "Isolated Organ Bath Setup & Tissue Bioassays",
    "Dose-Response Curve (DRC) Determination (Agonist & Antagonist Studies)",
    "Calculation of EC50, ED50, pD2, and pA2 Values of Drugs",
    "Animal / Simulated Model Experiments for Analgesia, Epilepsy & Inflammation",
    "Blood Sampling & Oral Gavage Administration in Animal Models",
  ],
  "Clinical Pharmacology & Pharmacovigilance": [
    "Adverse Drug Reaction (ADR) Monitoring & Causality Assessment (WHO-UMC / Naranjo Scale)",
    "Rational Prescription Writing & Prescription Audit Analysis",
    "Preparation of Stock Solutions, Reagents & Serial Drug Dilutions",
    "Therapeutic Drug Monitoring (TDM) & Pharmacokinetic Parameter Calculations",
  ],
};

export const PHARMACOLOGY_CATEGORIES = Object.keys(PHARMACOLOGY_PROCEDURES);

export const isMDInPharmacologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("pharmacology") && !d.includes("clinical pharmacology");
};
